import { BullhornCreateNoteComponent } from '../bullhorn-create-note/bullhorn-create-note.component';
import { SalesforceCreateCallComponent } from '../salesforce-create-call/salesforce-create-call.component';
import { UpdateFieldComponent } from '../update-field/update-field.component';
import { UpdateFieldService } from '../update-field/update-field.service';

export class ActionService {
  public static getActionFormGroupByAction(action: any, namespace: string, triggerId?: string) {
    if (!action) {
      return undefined;
    }
    if (BullhornCreateNoteComponent.isAction(action)) {
      return BullhornCreateNoteComponent.createFormGroup(action, triggerId);
    }
    if (SalesforceCreateCallComponent.isAction(action)) {
      return SalesforceCreateCallComponent.createFormGroup(action, triggerId);
    }
    if (UpdateFieldService.isAction(action)) {
      return UpdateFieldService.createFormGroup(namespace, action);
    }
  }

  public static getActionFormGroupByName(actionName: string, namespace: string, triggerId?: string) {
    if (!actionName) {
      return undefined;
    }
    switch (actionName) {
      case BullhornCreateNoteComponent.NAME:
        return BullhornCreateNoteComponent.createFormGroup(undefined, triggerId);
      case SalesforceCreateCallComponent.NAME:
        return SalesforceCreateCallComponent.createFormGroup(undefined, triggerId);
      case UpdateFieldComponent.NAME:
        return UpdateFieldService.createFormGroup(namespace);
    }
  }
}
